import Api from 'src/api/Base'

class GetExportPosAdvice extends Api {
  requestUrl = `/api/Export/PosAdvice`

  method = 'POST'
}

export default GetExportPosAdvice
